import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { links } from '../../common/links';
import { PiLayoutDuotone, PiCloudDuotone, PiMagicWandDuotone, PiUserCircleDuotone, PiCaretLeftBold, PiCaretRightBold } from 'react-icons/pi';
import FreeCard from './FreeCard';

function Sidebar() {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getIcon = (name) => {
    switch (name) {
      case 'My Space': return <PiCloudDuotone className="text-xl shrink-0" />;
      case 'Image Editor': return <PiMagicWandDuotone className="text-xl shrink-0" />;
      case 'Profile': return <PiUserCircleDuotone className="text-xl shrink-0" />;
      default: return null;
    }
  };

  return (
    <div className={`relative transition-all duration-300 ease-in-out hidden lg:flex md:flex flex-col bg-[#80cde8] h-screen border-r border-[#6fb4cc] shadow-sm z-50 ${
      isCollapsed ? 'w-[80px]' : 'w-[260px]'
    }`}>
      {/* Collapse Toggle */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-8 bg-white border border-gray-200 rounded-full p-1 shadow-md hover:scale-110 transition-all z-50 text-gray-600 hover:text-blue-500"
      >
        {isCollapsed ? <PiCaretRightBold size={14} /> : <PiCaretLeftBold size={14} />}
      </button>

      {/* Brand Section */}
      <div className={`p-6 transition-all duration-300 ${isCollapsed ? 'px-3' : 'px-6'}`}>
        <Link 
          to='/home' 
          className={`flex items-center bg-white/70 backdrop-blur-md hover:bg-white/90 transition-all shadow-sm rounded-xl group ${
            isCollapsed ? 'justify-center p-2 py-1' : 'gap-3 px-4 py-3'
          }`}
        >
          <img 
            src={require('../assert/logo.ico')} 
            className="h-10 w-10 object-contain group-hover:scale-110 transition-transform shrink-0" 
            alt="Logo"
          />
          {!isCollapsed && <span className="text-gray-800 text-xl font-extrabold tracking-tight truncate">Cloud Point</span>}
        </Link>
      </div>

      {/* Navigation Section */}
      <div className="flex-1 px-3 flex flex-col gap-2 overflow-y-auto">
        {!isCollapsed && <p className="text-[10px] font-bold text-gray-700 uppercase tracking-widest px-3 mb-2">Main Menu</p>}
        
        <Link 
          to="overview" 
          title={isCollapsed ? "Overview" : ""}
          className={`flex items-center rounded-xl transition-all font-semibold ${
            isCollapsed ? 'justify-center p-3' : 'gap-3 px-4 py-3'
          } ${
            location.pathname.endsWith('overview') 
              ? 'bg-gray-800 text-white shadow-lg translate-x-1' 
              : 'text-gray-700 hover:bg-white/30 hover:text-gray-900'
          }`}
        >
          <PiLayoutDuotone className="text-xl shrink-0" />
          {!isCollapsed && <span>Overview</span>}
          {!isCollapsed && location.pathname.endsWith('overview') && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white/80" />}
        </Link>

        {links.map((link, index) => {
          const isActive = location.pathname.includes(link.link);
          return (
            <Link 
              to={link.link} 
              key={index} 
              title={isCollapsed ? link.name : ""}
              className={`flex items-center rounded-xl transition-all font-semibold ${
                isCollapsed ? 'justify-center p-3' : 'gap-3 px-4 py-3'
              } ${
                isActive 
                  ? 'bg-gray-800 text-white shadow-lg translate-x-1' 
                  : 'text-gray-700 hover:bg-white/30 hover:text-gray-900'
              }`}
            >
              {getIcon(link.name)}
              {!isCollapsed && <span>{link.name}</span>}
              {!isCollapsed && isActive && <div className="ml-auto w-1.5 h-1.5 rounded-full bg-white/80" />}
            </Link>
          );
        })}
      </div>

      {/* Footer / Card Section */}
      <div className="p-3 mt-auto">
        <FreeCard isCollapsed={isCollapsed} />
      </div>
    </div>
  );
}

export default Sidebar;
